import './src/styles/global.css';
import React from 'react';
import Layout from './src/components/Layout';
import MicrositeLayout from './src/components/MicrositeLayout';
import { GatsbyBrowser } from 'gatsby';
import { headerOffsetPx } from './src/styles/headerOffset';

export const wrapPageElement: GatsbyBrowser<any>['wrapPageElement'] = ({
  element,
  props,
}) => {
  return props.data.contentfulV2MicrositePage ? (
    <MicrositeLayout {...props}>{element as any}</MicrositeLayout>
  ) : (
    <Layout {...props}>{element as any}</Layout>
  );
};

// Track back/forward navigation directly.
let isHistoryPop = false;

export const onClientEntry: GatsbyBrowser['onClientEntry'] = () => {
  window.addEventListener('popstate', () => {
    isHistoryPop = true;
  });
};

export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  if (isHistoryPop) {
    const savedPosition = getSavedScrollPosition(location);
    window.scrollTo(...((savedPosition as [number, number]) || [0, 0]));
    return false;
  }

  if (!location.hash) {
    window.scrollTo(0, 0);
  }

  return false;
};

const scrollToHashWithOffset = (hash: string) => {
  const id = decodeURI(hash.slice(1));
  const el = id ? document.getElementById(id) : null;
  if (!el) return;
  const top = el.getBoundingClientRect().top + window.scrollY - headerOffsetPx;
  window.scrollTo(0, Math.max(0, top));
};

// Runs after gatsby-plugin-anchor-links, which would otherwise scroll to the hash.
export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location }) => {
  isHistoryPop = false;

  if (location.hash) {
    scrollToHashWithOffset(location.hash);
  }
};

// This replaces the default hydration function with a function that takes a container, created a root node from it and then attaches the child element.
// 1) https://www.gatsbyjs.com/docs/conceptual/react-hydration/#the-reactdomclienthydrateroot-method
// 2) https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/#replaceHydrateFunction
// export const replaceHydrateFunction = () => {
//   return (element: React.ReactNode, container: ReactDOM.Container) => {
//     // Documentation around createRoot:  https://react.dev/reference/react-dom/client/createRoot
//     const root = ReactDOM.createRoot(container);
//     root.render(element);
//   };
// };
